module.exports = __webpack_public_path__ + "img/mz.3a028fbe.svg";